import { createFileRoute } from '@tanstack/react-router';
import { MemberProfileView } from '@/profile/MemberProfileSections';

export const Route = createFileRoute('/_app/_users/members/$memberId/profile/')(
  {
    component: MemberProfileRoute,
  },
);

function MemberProfileRoute() {
  const { memberId } = Route.useParams();
  return <MemberProfileView memberId={memberId} />;
}
